import { PayloadAction } from '@reduxjs/toolkit';
import { AccountsState, JoinInfo, SocialAccounts } from './state';
import { SocialLogin, TokenRefresh, User } from './type';

const reducers = {
  setLogout(state: AccountsState): AccountsState {
    state.isLogin = false;
    state.socialAccounts = null;
    state.user = null;
    state.access = '';
    state.join_info = null;
    state.refresh = null;

    return state;
  },
  setJoinInfo(state, action: PayloadAction<JoinInfo>) {
    state.join_info = action.payload;
    return state;
  },
  setLogin(state, action: PayloadAction<boolean>) {
    state.isLogin = action.payload;
    return state;
  },
  setRefreshToken(state, action: PayloadAction<TokenRefresh>) {
    state.refresh = action.payload;
    return state;
  },
  setSNSInfo(state, action: PayloadAction<string>) {
    state.join_info = {
      name: '',
      phone_number: '',
      socialaccounts: [action.payload],
    };
    return state;
  },
  setSocialToken(state, action: PayloadAction<SocialLogin>) {
    state.social = action.payload;
    return state;
  },
  setSocialEmail(state, action: PayloadAction<string>) {
    state.socialMail = action.payload;
    return state;
  },
  setAccessToken(state, action: PayloadAction<string>) {
    state.access = action.payload;
    return state;
  },
  setUserInfo(state, action: PayloadAction<User>) {
    state.user = action.payload;
    return state;
  },
  setSocialAccounts(state, action: PayloadAction<SocialAccounts>) {
    state.socialAccounts = action.payload;
    return state;
  },
  setSocialAccountData(state, action: PayloadAction<any>) {
    state.socialAccountData = action.payload;
    return state;
  },
};

export default reducers;
